import React from 'react'
import { ButtonGroup, Button } from 'reactstrap'
import SportIcon from './SportIcon'
import { hasTabs } from '../utils/categoryFilterVariant'
import './CategoryFilter.css'

const APPINITLANG = 'fi'

const iconName = (c) => (c.icon ? c.icon.toLowerCase() : c.label[APPINITLANG].toLowerCase())

// A category's own picture (`categories[].image`, a URL on the init doc) replaces the sport icon:
// not every venue sells a sport (Boksi: rooms, birthday parties, evenings).
const CategoryImage = ({ category, className, style }) => (
  <img src={category.image} alt='' className={className} style={style} />
)

// The category (venue / sport) filter on the booking page. `variant` comes from
// utils/categoryFilterVariant.js: 'default' is the plain button group every venue has had.
function CategoryFilter({ categories, selected, onSelect, variant = 'default' }) {
  if (hasTabs(variant)) {
    return (
      <div className={'catfilter-tabs' + (variant === 'largetabs' ? ' large' : '')} role='tablist'>
          {categories.map((c) => {
            const isSelected = selected === c.category
            return (
              <button
                type='button'
                role='tab'
                aria-selected={isSelected}
                key={c.category}
                className={'catfilter-tab' + (isSelected ? ' selected' : '')}
                onClick={() => onSelect(c.category)}
              >
                {c.image ? (
                  <CategoryImage category={c} className='catfilter-image' />
                ) : (
                  <SportIcon sport={iconName(c)} fontSize={'small'} />
                )}
                {c.label[APPINITLANG]}
              </button>
            )
          })}
      </div>
    )
  }

  return (
    <ButtonGroup size={'sm'} className='flex-wrap'>
      {categories.map((c) => {
        const iconStroke = selected === c.category ? '#fff' : '#007bff'
        return (
          <Button
            size={'sm'}
            key={c.category}
            color='primary'
            onClick={() => onSelect(c.category)}
            active={selected === c.category}
            outline
            onMouseOver={(e) => {
              e.currentTarget.style.stroke = '#efefef'
            }}
            onMouseOut={(e) => {
              e.currentTarget.style.stroke = iconStroke
            }}
            style={{
              stroke: iconStroke,
            }}
          >
            {c.image ? (
              <CategoryImage category={c} style={{ height: 18, marginRight: 5, marginBottom: 2, verticalAlign: 'middle' }} />
            ) : (
              <SportIcon style={{ marginRight: 5, marginBottom: 2 }} sport={iconName(c)} fontSize={'small'} />
            )}
            {c.label[APPINITLANG]}
          </Button>
        )
      })}
    </ButtonGroup>
  )
}

export default CategoryFilter
